import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "Американский футбол",
    Baseball: "Бейсбол",
    Basketball: "Баскетбол",
    Boxing: "Бокс",
    Chess: "Шахматы",
    Cricket: "Крикет",
    Darts: "Дартс",
    Entertainment: "Развлечение",
    "E-Sports": "Киберспорт",
    Football: "Футбол",
    "Formula 1": "Формула-1",
    "Gaelic Football": "Гэльский футбол",
    "Generic Sport": "Общий спорт",
    Golf: "Гольф",
    "Greyhound Racing": "Собачьи бега (борзые)",
    Handball: "Гандбол",
    "Ice Hockey": "Хоккей",
    IndyCar: "Гонки Инди",
    MMA: "MMA",
    Nascar: "NASCAR",
    Politics: "Политика",
    "Rugby League": "Регби Лиг",
    "Rugby Union": "Регби Юнион",
    Snooker: "Снукер",
    "Table Tennis": "Настольный теннис",
    Tennis: "Теннис",
    "Virtual Football": "Виртуальный футбол",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{name} для победы",
    WinFirstRound: "{name}, чтобы выиграть первый раунд",
    FirstTouchdown: "{name} первым забьет тачдаун",
    FirstTry: "{name}, чтобы забить попытку первым",
    TotalGoals: "{name} Тотал голов",
    TotalRuns: "{name} Тотал ранов",
    TotalPoints: "{name} Тотал очков",
    TopBatsman: "{name} будет лучшим бэтменом",
    TopBowler: "{name} будет лучшим бойлером",
    FirstScore: "{name} забьет первым"
  },
  PromoTexts: {
    Pick: "Сделайте свой выбор",
    Bet: "Ставка",
    Pays: "Выплата"
  },
  DateTimeTexts: {
    Today: "Сегодня",
    Tomorrow: "Завтра",
    Live: "Лайв"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "Сделайте свой выбор",
    Return: "Выплата",
    Stake: "Ставка",
    Draw: "X"
  },
  H2HTexts: {
    goals_scored: "Забитые голы",
    shots: "Удары",
    shots_on_target: "Удары по воротам",
    ball_possession: "Владение мячом",
    goals_conceded: "Пропущеннные голы",
    "Per match": "за матч",
    H2H: "Очные",
    W: "В",
    D: "Н",
    L: "П",
    T: "Н",
    // baseball
    runs_per_game: "Runs",
    runs_allowed_per_game: "Runs Allowed",
    hits_per_game: "Hits",
    batting_average: "AVG",
    on_base_percentage: "OBP",
    slugging_percentage: "SLG",
    home_runs: "HR",
    stolen_bases: "SB",
    earned_run_average: "ERA",
    walks_hits_per_inning_pitched: "WHIP",
    strikeouts_per_9_innings: "K/9",
    homeruns_allowed_per_game: "HR",
    batting_average_against: "BA",
    batting_stats: "Batting/Running",
    pitching_stats: "Pitching/Defence",

    // american football
    points_per_game: "Points",
    points_allowed_per_game: "Points Allowed",
    rushing_stats: "Rushing Stats",
    rushing_yards_per_game: "Rushing Yards",
    rushing_touchdowns: "Rushing Touchdowns (total)",
    rushing_percentage: "Rushing %",
    passing_stats: "Passing Stats",
    passing_yards_per_game: "Passing Yards",
    passing_touchdowns: "Passing Touchdowns (total)",
    passing_percentage: "Passing %"
  }
};
